<!-- WonderYjjRate.vue -->
 <!-- 资金流入分析 -->
<template>
	<div class="wonder-ml-page">
		<div class="row mb-3">
			<div class="col-12">
				<div class="d-flex align-items-center flex-wrap">
					<b-form-datepicker
						id="datepicker"
						v-model="selectedEndDate"
						:min="minDate"
						:max="maxDate"
						locale="zh"
						today-button
						reset-button
						close-button
						placeholder="选择日期"
						@input="onDateChange"
						class="mr-3"
					></b-form-datepicker>
					<div class="d-flex align-items-center flex-wrap mt-1">
						<span class="ml-2" style="font-size: 14px; color: #666;">显示最近
							<b-form-select v-model.number="dayn" :options="daynOptions" size="sm" class="ml-2 w-auto" @change="onDaynChange"></b-form-select>个交易日
						</span>
						<span class="ml-3" style="font-size: 14px; color: #666;">显示Top
							<b-form-select v-model.number="topN" :options="topNOptions" size="sm" class="ml-1 w-auto" @change="saveSettings"></b-form-select>
						</span>
						<b-form-checkbox v-model="showMoney" switch class="ml-3">资金</b-form-checkbox>
						<b-form-checkbox v-model="showScore" switch class="ml-3">强度</b-form-checkbox>
						<b-form-checkbox v-model="showRate" switch class="ml-3">涨幅</b-form-checkbox>
						<b-form-checkbox v-if="isAdmin" v-model="showKP" switch class="ml-3">KP</b-form-checkbox>
						<b-form-radio-group
							v-model="selectedCycle"
							:options="cycleOptions"
							buttons
							button-variant="outline-primary"
							size="sm"
							class="ml-3"
						></b-form-radio-group>
						<span class="ml-2" style="font-size: 14px; color: #666;">周期</span>
						<b-form-radio-group
							v-model="selectedNType"
							:options="nTypeOptions"
							buttons
							button-variant="outline-primary"
							size="sm"
							class="ml-3"
						></b-form-radio-group>
						<span class="ml-2" style="font-size: 14px; color: #666;">排序</span>
						<b-form-checkbox v-model="showUplimitStepFlag" switch class="ml-3">涨停梯队</b-form-checkbox>
						<b-form-checkbox v-model="focusEnabled" switch class="ml-3">符</b-form-checkbox>
						<b-form-checkbox v-model="showMinChart" switch class="ml-3">分时</b-form-checkbox>
						<span v-if="row4Mode === 'popular'" class="ml-3" style="font-size: 14px; color: #666;">人气Top
							<b-form-select v-model.number="popularLimit" :options="popularLimitOptions" size="sm" class="ml-1 w-auto" style="width: 65px;"></b-form-select>
						</span>
						<span v-if="row4Mode === 'pct'" class="ml-3" style="font-size: 14px; color: #666;">统计周期
							<b-form-select v-model.number="cumDays" :options="cumDaysOptions" size="sm" class="ml-1 w-auto" style="width: 75px;"></b-form-select>
						</span>
						<span class="ml-3" style="font-size: 14px; color: #666;">板块ID</span>
						<b-form-input v-model.trim="plateCodeInput" size="sm" class="ml-2" style="width: 140px;" placeholder="输入板块ID"></b-form-input>
					</div>
				</div>

			</div>
				
		</div>
		<!-- 第一行：题材列表 -->
		<div class="row no-gutters flex-nowrap">
			<!-- 左侧 排名 sidebar -->
			<div class="col-auto px-1" style="width: 50px;">
				<div class="date-header">
					排名
				</div>
				<div class="ranking-items-container" :class="{'has-row2': showMoney}">
					<div v-for="i in topN" :key="'rank-'+i" class="mb-1 text-center">
						<div class="ranking-item d-flex align-items-center justify-content-center" :class="{'ranking-highlight-1': i===1, 'ranking-highlight-2': i===2 || i===3}">
							{{ i }}
						</div>
					</div>
				</div>
			</div>
			
			<!-- 右侧数据列 -->
			<div class="col overflow-hidden" style="min-width: 0;">
				<div class="row no-gutters flex-nowrap" style="overflow-x: auto;" ref="scrollTopic" @scroll="handleScroll('scrollTopic')">
					<template v-if="days.length">
						<RateRangePlate class="px-2 col" style="min-width: var(--col-width, 140px);" v-for="day in days" :date1="day" :key="day + '-' + selectedEndDate" :plate_type=17
							:selectedPlateCode="selectedPlateCode" :selectedPlateName="selectedPlateName" 
							:is_show_row2="showMoney" :data_src="showKP ? 2 : 1" :n_days="selectedCycle" :n_type="selectedNType" :showUplimitStep="0"
							:focusEnabled="focusEnabled" :showMinChart="showMinChart" :prevCodes="prevCodesByDay[day] || []" :show_score="showScore ? 1 : 0" :show_rate="showRate"
							:top_n="topN" :showDatePicker="false"
							@plate-selected="handlePlateSelected"
							@show_sidebar="show_sidebar" @first-plate-loaded="handleFirstPlateLoaded" @show-plate-kline="handleShowPlateKline" @plates-loaded="handlePlatesLoaded">
						</RateRangePlate>
					</template>
				</div>
			</div>
		</div>

		<!-- 第二行：板块强度图表 -->
		<div class="row no-gutters mt-2 flex-nowrap" v-if="selectedPlateCode">
			<div class="col-auto px-1 border-right" style="width: 50px; display: flex; align-items: center; justify-content: center;">
				<div style="font-size: 12px; font-weight: bold; color: #ced4da; writing-mode: vertical-lr; letter-spacing: 4px;">板块强度</div>
			</div>
			<div class="col px-0 overflow-hidden" ref="scrollIntensity" @scroll="handleScroll('scrollIntensity')" style="overflow-x: auto;">
                <div :style="{ width: 'calc(var(--col-width, 140px) * ' + days.length + ')', minWidth: '100%' }">
                    <PlateIntensityChart :days="days" :trendData="trendData" />
                </div>
			</div>
		</div>

		<!-- 第三行：成交额图表 -->
		<div class="row no-gutters mt-2 flex-nowrap" v-if="selectedPlateCode">
			<div class="col-auto px-1 border-right" style="width: 50px; display: flex; align-items: center; justify-content: center;">
				<div style="font-size: 12px; font-weight: bold; color: #ced4da; writing-mode: vertical-lr; letter-spacing: 4px;">成交额</div>
			</div>
			<div class="col px-0 overflow-hidden" ref="scrollVolume" @scroll="handleScroll('scrollVolume')" style="overflow-x: auto;">
                <div :style="{ width: 'calc(var(--col-width, 140px) * ' + days.length + ')', minWidth: '100%' }">
                    <PlateVolumeChart :days="days" :trendData="trendData" />
                </div>
			</div>
		</div>

		<!-- 第四行：内容切换 (梯队/人气/涨幅/K线) -->
		<div class="row no-gutters mt-2 flex-nowrap" v-if="selectedPlateCode">
			<div class="col-auto px-1 border-right" style="width: 50px;">
				<div class="pt-1 text-center d-flex flex-column align-items-center">
					<div 
						class="mode-switch-item mb-2" 
						:class="{'active': row4Mode === 'step'}"
						@click="clickTab('step')"
						title="梯队详情"
					>梯队</div>
					<div 
						class="mode-switch-item mb-2" 
						:class="{'active': row4Mode === 'popular'}"
						@click="clickTab('popular')"
						title="人气表格"
					>人气</div>
					<div 
						class="mode-switch-item mb-2" 
						:class="{'active': row4Mode === 'pct'}"
						@click="clickTab('pct')"
						title="累计涨幅"
					>涨幅</div>
					<div 
						class="mode-switch-item" 
						:class="{'active': row4Mode === 'kline'}"
						@click="clickTab('kline')"
						title="板块K线"
					>K线</div>
				</div>
			</div>
			<div class="col pl-0 overflow-hidden">
				<!-- 梯队模式 -->
				<div v-if="row4Mode === 'step'" class="row no-gutters flex-nowrap" style="overflow-x: auto;" ref="scrollLadder" @scroll="handleScroll('scrollLadder')">
					<div class="col px-2" style="min-width: var(--col-width, 140px);" v-for="day in days" :key="'step-'+day">
						<UplimitStepOnPlate :plate_code="selectedPlateCode" :date1="day" @show_sidebar="show_sidebar" @show-plate-kline="handleShowPlateKline"></UplimitStepOnPlate>
					</div>
				</div>
				<!-- 人气模式 -->
				<div v-else-if="row4Mode === 'popular'" class="row no-gutters flex-nowrap" style="overflow-x: auto;" ref="scrollPopular" @scroll="handleScroll('scrollPopular')">
					<div class="col px-2" style="min-width: var(--col-width, 140px);" v-for="(day, idx) in days" :key="'popular-'+day">
						<PopularListOnPlate 
							:plate_code="selectedPlateCode" 
							:date1="day" 
							:is-latest="idx === 0"
							:highlight-stock-name="activeHighlightStock"
							:limit="popularLimit"
							@latest-first-stock="handleLatestFirstStock"
							@stock-clicked="handleStockClicked"
							@show_sidebar="show_sidebar"
						></PopularListOnPlate>
					</div>
				</div>
				<!-- 涨幅模式 -->
				<div v-else-if="row4Mode === 'pct'" class="position-relative" style="min-height: 200px;">
					<div v-if="requireRotationSubscription" class="locked-overlay d-flex flex-column align-items-center justify-content-center p-4 text-center">
						<div class="lock-circle mb-3">
							<b-icon icon="lock-fill" font-scale="1.8"></b-icon>
						</div>
						<h5 class="font-weight-bold mb-2">开通涨幅区间 VIP</h5>
						<p class="text-muted small mb-3">您今日的免费试用次数（3次）已用完，请订阅该功能模块以获得无限次访问。</p>
						<b-button size="sm" variant="warning" class="rounded-pill px-4 font-weight-bold" @click="$router.push({ path: '/subscription', query: { module: 'pct_interval_vip' }})">
							立即订阅
						</b-button>
					</div>

					<div :class="{'blur-content': requireRotationSubscription}">
						<div class="row no-gutters flex-nowrap" style="overflow-x: auto;" ref="scrollPct" @scroll="handleScroll('scrollPct')">
							<div class="col px-2" style="min-width: var(--col-width, 140px);" v-for="day in days" :key="'pct-'+day">
								<PlateStockPctOnPlate
									:plate_code="selectedPlateCode"
									:date1="day"
									:daysBack="cumDays"
									:stocksData="pctDataMap[day]"
									:loadingProp="loadingPct"
									is-batch
									:highlight-stock-name="selectedStockNamePct"
									@stock-clicked="handleStockClickedPct"
									@show_sidebar="show_sidebar"
								></PlateStockPctOnPlate>
							</div>
						</div>
					</div>
				</div>
				<!-- K线模式 -->
				<div v-else-if="row4Mode === 'kline'">
					<StockKlineDay :symbol_code="selectedPlateCode" :title="selectedPlateName" :subText="selectedPlateCode" :highlightDate="selectedDate" :chart_heigh="'450px'" :zoom_start="40"></StockKlineDay>
					
					<!-- 板块爆发原因 -->
					<div class="plate-reasons" v-if="selectedPlateCode">
						<div class="plate-reasons-header">
							<h5>板块爆发原因</h5>
							<span v-if="loadingReasons" class="loading">加载中...</span>
						</div>
						<div v-if="!loadingReasons && reasonAuthRequired" class="empty">
							需要登录后查看板块爆发原因 
							<b-button size="sm" variant="outline-primary" class="login-btn" @click="goLogin">去登录</b-button>
						</div>
						<div v-else-if="!loadingReasons && plateReasons.length === 0" class="empty">暂无数据</div>
						<div v-else class="reasons-list">
							<div class="reason-item" v-for="(r, idx) in plateReasons" :key="r.newid || idx">
								<div class="reason-title">
									<span class="date">{{ r.date }}</span>
									<span class="boom" v-if="r.isboom">爆发</span>
									<a href="#" class="title" @click.prevent="toggleReason(r)">{{ r.title }}</a>
								</div>
								<div class="reason-meta">
									<span v-if="r.ztnum != null">涨停数：{{ r.ztnum }}</span>
									<span v-if="r.index != null">指数：{{ r.index }}</span>
									<span v-if="r.qd != null">强度：{{ r.qd }}</span>
								</div>
								<div class="reason-text" v-if="r.boomreason">{{ r.boomreason }}</div>
								<div class="reason-lz" v-if="r.lzinfo">龙头：{{ r.lzinfo }}</div>
								<div class="reason-content" v-if="reasonExpanded[r.newid]">
									<div v-if="reasonLoadingContent[r.newid]" class="loading">内容加载中...</div>
									<div v-else>
										<div class="reason-detail-meta" v-if="reasonContentMap[r.newid] && reasonContentMap[r.newid].createTime">
											时间：{{ formatReasonTimestamp(reasonContentMap[r.newid].createTime) }}
										</div>
										<div v-html="reasonContentMap[r.newid] && reasonContentMap[r.newid].content"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>



        <!-- 板块K线图（组件化） -->
        <PlateKlineModal
            :visible="showPlateKline"
            :plateCode="selectedPlateCode"
            :plateName="selectedPlateName"
            :selectedDate="selectedDate"
            @close="closePlateKline"
        />

		<StockInfoSidebar :symbol_code="symbol_code" :symbol_name="symbol_name" :date_mark="date_mark"></StockInfoSidebar>
		<LoginModal ref="loginModal" @success="onLoginSuccess" />
	</div>
	
</template>

<script>
    import YjjMixin from '../../mixins/views/wonder/YjjMixin.js'
    import moment from 'moment'
    import { request_zzquant } from "network/request.js"
    import PlateKlineModal from 'components/plate/PlateKlineModal.vue'
    import StockInfoSidebar from 'components/stock/StockInfoSidebar.vue'
    import PlateIntensityChart from 'components/plate/PlateIntensityChart.vue'
    import PlateVolumeChart from 'components/plate/PlateVolumeChart.vue'
    import UplimitStepOnPlate from 'components/uplimit/UplimitStepOnPlate.vue'
    import PopularListOnPlate from 'components/uplimit/PopularListOnPlate.vue'
    import PlateStockPctOnPlate from 'components/uplimit/PlateStockPctOnPlate.vue'
    import LoginModal from '@/components/login/LoginModal'


    export default {
        mixins: [YjjMixin],
        data() {
			return {
				minDate: moment().subtract(3, 'year').format('YYYY-MM-DD'),
				maxDate: moment().format('YYYY-MM-DD'),
				// 如果当前时间是在09:31之前或者是凌晨时间段，则结束日期不加一天
				selectedEndDate: (() => {
					const now = moment();
					const currentTime = now.format('HH:mm');					
					if (currentTime < '09:31'){
						return now.format('YYYY-MM-DD');
					} else {
						return now.add(1, 'days').format('YYYY-MM-DD');
					}
				})(),
				showMoney: false, // 控制是否显示资金的开关
			showScore: true, // 控制是否显示分数
            showRate: true, // 控制是否显示涨幅（在标题括号中）
			showKP: false, // 控制是否使用KP数据源
			showPlateKline: false,
			firstPlateSet: false,
			selectedCycle: 1, // 默认选择1日周期
			cycleOptions: [
				{ text: '1日', value: 1 },
				{ text: '3日', value: 3 },
				{ text: '5日', value: 5 }
			],
			selectedNType: 9, // 默认“强度”
			nTypeOptions: [
				{ text: '资金', value: 3 },
				{ text: '强度', value: 9 },
				{ text: '涨幅', value: 1 }
			],
				showUplimitStepFlag: false, // 控制是否显示涨停梯队的开关
				showMinChart: false,
				focusEnabled: false,
				plateCodeInput: '',
					prevCodesByDay: {},
					loadedCodesByDay: {},
					allDays: [],
					daynOptions: [6,8,10,12,15],
				trendData: [], // Trend data for charts
					topN: 12, // 显示top N个板块
					topNOptions: [8, 10, 12, 20],
					// 板块爆发原因
					plateReasons: [],
					loadingReasons: false,
					reasonAuthRequired: false,
					reasonContentMap: {},
					reasonLoadingContent: {},
					reasonExpanded: {},
					row4Mode: 'kline', // 'step', 'popular', 'kline', 'pct'
					latestFirstStock: null,
					selectedStockName: null,
					popularLimit: 20,
					popularLimitOptions: [20, 30, 50, 100],
					cumDays: 10,
					cumDaysOptions: [5, 10, 20],
					pctDataMap: {},
					loadingPct: false,
					requireRotationSubscription: false,
					selectedStockNamePct: null
				}
        },
        created() {
            this.loadSettings();
        },
        mounted() {
            // 设置默认日期为当天
            if (!this.selectedDate) {
                // 如果当前时间是在09:31之前或者是凌晨时间段（00:00-04:00），则取前一天的日期
                const now = moment();
                this.selectedDate = now.format('YYYY-MM-DD');
            }
        },
        computed: {
            isAdmin(){
                try{
                    const raw = localStorage.getItem('user_info')
                    if(!raw) return false
                    const u = JSON.parse(raw)
                    const r = u && u.roles
                    const arr = Array.isArray(r) ? r : String(r||'').split(',').map(s=>s.trim()).filter(Boolean)
                    return arr.includes('admin')
                }catch(e){ return false }
            },
            activeHighlightStock() {
                return this.selectedStockName || this.latestFirstStock;
            }
        },
		watch: {
			topN(){ this.saveSettings(); this.updatePrevCodesByDay(); },
			// 监听KP开关状态变化，触发数据刷新
			showKP(){ this.saveSettings(); this.get_trade_days(); },
			showScore(){ this.saveSettings(); },
            showRate(){ this.saveSettings(); },
			focusEnabled(){ this.saveSettings(); this.updatePrevCodesByDay(); },
			selectedCycle(){ this.saveSettings(); this.updatePrevCodesByDay(); },
            selectedNType(){ this.saveSettings(); this.updatePrevCodesByDay(); },
            dayn(){ this.saveSettings(); this.get_trade_days(); },
            showMoney(){ this.saveSettings(); },
            showUplimitStepFlag(){ this.saveSettings(); },
            showMinChart(){ this.saveSettings(); },
            popularLimit(){ this.saveSettings(); },
            cumDays(){ 
                this.saveSettings(); 
                if (this.row4Mode === 'pct') {
                    this.fetchPctBatch();
                }
            },
            selectedPlateCode(val) {
				if (val !== this.plateCodeInput) {
					this.plateCodeInput = val || '';
				}
				this.latestFirstStock = null;
				this.selectedStockName = null;
				this.selectedStockNamePct = null;
                if (val) {
                    this.fetchTrend();
                    this.loadPlateReasons();
                    if (this.row4Mode === 'pct') {
                        this.fetchPctBatch();
                    }
                }
            },
			plateCodeInput(val){
				const next = (val || '').trim();
				if (next === this.selectedPlateCode) return;
				this.selectedPlateCode = next;
			},
            days: {
                handler(val) {
					this.latestFirstStock = null;
					this.selectedStockName = null;
					this.selectedStockNamePct = null;
                    if (val && val.length > 0 && this.selectedPlateCode) {
                        this.fetchTrend();
                        if (this.row4Mode === 'pct') {
                            this.fetchPctBatch();
                        }
                    }
                }
            },
            row4Mode(val) {
                if (val === 'pct') {
                    this.fetchPctBatch();
                }
            }
        },
        components: {
            PlateKlineModal,
            StockInfoSidebar,
            PlateIntensityChart,
            PlateVolumeChart,
            UplimitStepOnPlate,
            PopularListOnPlate,
            PlateStockPctOnPlate,
            LoginModal
        },
        methods: {
            loadSettings() {
                try {
                    const settings = localStorage.getItem('WonderYjjRateML_Settings');
                    if (settings) {
                        const parsed = JSON.parse(settings);
                        if (parsed.dayn !== undefined) this.dayn = parsed.dayn;
                        if (parsed.showMoney !== undefined) this.showMoney = parsed.showMoney;
                        if (parsed.showScore !== undefined) this.showScore = parsed.showScore;
                        if (parsed.showRate !== undefined) this.showRate = parsed.showRate;
                        if (parsed.showKP !== undefined) this.showKP = parsed.showKP;
                        if (parsed.selectedCycle !== undefined) this.selectedCycle = parsed.selectedCycle;
                        if (parsed.selectedNType !== undefined) this.selectedNType = parsed.selectedNType;
                        if (parsed.showUplimitStepFlag !== undefined) this.showUplimitStepFlag = parsed.showUplimitStepFlag;
                        if (parsed.showMinChart !== undefined) this.showMinChart = parsed.showMinChart;
                        if (parsed.focusEnabled !== undefined) this.focusEnabled = parsed.focusEnabled;
                        if (parsed.topN !== undefined) this.topN = parsed.topN;
                        if (parsed.popularLimit !== undefined) this.popularLimit = parsed.popularLimit;
                        if (parsed.cumDays !== undefined) this.cumDays = parsed.cumDays;
                    }
                } catch (e) {
                    console.error('Failed to load settings', e);
                }
            },
            saveSettings() {
                try {
                    const settings = {
                        dayn: this.dayn,
                        showMoney: this.showMoney,
                        showScore: this.showScore,
                        showRate: this.showRate,
                        showKP: this.showKP,
                        selectedCycle: this.selectedCycle,
                        selectedNType: this.selectedNType,
                        showUplimitStepFlag: this.showUplimitStepFlag,
                        showMinChart: this.showMinChart,
                        focusEnabled: this.focusEnabled,
                        topN: this.topN,
                        popularLimit: this.popularLimit,
                        cumDays: this.cumDays,
                    };
                    localStorage.setItem('WonderYjjRateML_Settings', JSON.stringify(settings));
                } catch (e) {
                    console.error('Failed to save settings', e);
                }
            },
			// 日期选择变化处理
			onDateChange() {
				// 重置状态以重新设置默认选中板块
				this.firstPlateSet = false;
				this.selectedPlateCode = "";
				this.latestFirstStock = null;
				this.selectedStockName = null;
				this.selectedStockNamePct = null;
				
				// 触发数据刷新
				this.get_trade_days();
			},
			// 首次板块加载时设置默认选中，避免未选中导致内容为空
			handleFirstPlateLoaded(plateCode, date) {
				if (!this.firstPlateSet && this.days && this.days.length > 0 && date === this.days[0]) {
					this.selectedPlateCode = plateCode;
					this.firstPlateSet = true;
				}
			},
			handleShowKline(stock_code, stock_name) {
				this.show_sidebar({
					stock_code: stock_code,
					stock_name: stock_name,
					date1: this.selectedDate
				});
			},
			handleShowSidebarFromTable(stock_code, stock_name) {
				this.show_sidebar({
					stock_code: stock_code,
					stock_name: stock_name,
					date1: this.selectedDate
				});
			},
			handleDateSelected(date) {
				this.selectedDate = date
			},
			show_sidebar(stock_info) {
				this.symbol_code = stock_info['stock_code'];
				this.symbol_name = stock_info['stock_name'];
				this.date_mark = stock_info['date1'];
			},
			handleLatestFirstStock(stockName) {
				this.latestFirstStock = stockName;
			},
			handleStockClicked(stockName) {
				if (this.selectedStockName === stockName) {
					this.selectedStockName = null;
				} else {
					this.selectedStockName = stockName;
				}
			},
			handleStockClickedPct(stockName) {
				if (this.selectedStockNamePct === stockName) {
					this.selectedStockNamePct = null;
				} else {
					this.selectedStockNamePct = stockName;
				}
			},
            fetchTrend() {
                if (!this.selectedPlateCode || !this.days || this.days.length === 0) {
                    this.trendData = [];
                    return;
                }
                
                const sortedDays = [...this.days].sort();
                const start = sortedDays[0];
                const end = sortedDays[sortedDays.length - 1];

                request_zzquant({
                    url: '/market/plates/17/trend',
                    params: {
                        plate_code: this.selectedPlateCode,
                        day_start: start,
                        day_end: end
                    }
                }).then(res => {
                    this.trendData = res.data.data || [];
                }).catch(err => {
                    console.error("Fetch trend error", err);
                    this.trendData = [];
                });
            },
            fetchPctBatch() {
                if (!this.selectedPlateCode || !this.days || this.days.length === 0) {
                    this.pctDataMap = {};
                    return;
                }
                this.loadingPct = true;
                this.requireRotationSubscription = false;
                const datesStr = this.days.join(",");
                request_zzquant({
                    url: `/v3/market/plates/17/${this.selectedPlateCode}/stocks/pct/batch`,
                    params: {
                        dates: datesStr,
                        days: this.cumDays
                    },
                    noRedirect: true
                }).then(res => {
                    const resData = res.data || {};
                    const innerData = resData.data || {};
                    this.pctDataMap = innerData;
                }).catch(err => {
                    const status = err.status || (err.response && err.response.status);
                    if (status === 401) {
                        if (this.$refs.loginModal) {
                            this.$refs.loginModal.show();
                        }
                    } else if (status === 403) {
                        this.requireRotationSubscription = true;
                        this.pctDataMap = {};
                    } else {
                        console.error("Fetch pct batch error:", err);
                        this.pctDataMap = {};
                    }
                }).finally(() => {
                    this.loadingPct = false;
                });
            },
            clickTab(mode) {
                if (mode === 'pct') {
                    const token = localStorage.getItem('token');
                    if (!token) {
                        if (this.$refs.loginModal) {
                            this.$refs.loginModal.show();
                        }
                        return;
                    }
                }
                this.row4Mode = mode;
            },
            onLoginSuccess() {
                this.row4Mode = 'pct';
                this.fetchPctBatch();
            },
			// 重写get_trade_days方法，使用selectedEndDate
			get_trade_days() {
				const today = this.selectedEndDate;
				request_zzquant({
						url: '/market/trade/days?day_end=' + today + '&days=' + (this.dayn + 3)
					})
					.then(res1 => {
						const raw = res1['data']['data'] || [];
						this.allDays = raw.slice().sort((a,b)=> new Date(b) - new Date(a));
						this.days = this.allDays.slice(0, this.dayn);
						this.selectedDate = this.days[0]
						this.prefetchPrevDaysForHighlights().then(()=>{ this.updatePrevCodesByDay(); });
					})
					.catch(err => {
						console.log(err);
					});
			},
			// 处理板块K线图显示
			handleShowPlateKline(plateInfo) {
				this.selectedPlateCode = plateInfo.code;
				this.selectedPlateName = plateInfo.name;
				this.showPlateKline = true;
			},
			
			// 关闭板块K线图
            closePlateKline() {
                this.showPlateKline = false;
            },
            onDaynChange(){ this.get_trade_days(); },
            handlePlatesLoaded(payload){
                if(payload && payload.day){
                    this.$set(this.loadedCodesByDay, payload.day, Array.isArray(payload.codes) ? payload.codes : []);
                    this.updatePrevCodesByDay();
                }
            },
			async updatePrevCodesByDay(){
				if(!this.focusEnabled || !this.days || this.days.length===0){ this.prevCodesByDay={}; return; }
				const map = {};
				for(let i=0;i<this.days.length;i++){
					const day=this.days[i];
					const prevDays=[];
					const idx = this.allDays.indexOf(day);
					for(let j=1;j<=3;j++){ const k=idx+j; if(k<this.allDays.length){ prevDays.push(this.allDays[k]); } }
					let codes=new Set();
					prevDays.forEach(d=>{ 
						const arr = this.loadedCodesByDay[d]; 
						if(arr && arr.length){ 
							// 重点：对比时只取前 Top N 个板块，这样才能准确识别“新进入 Top N”的板块
							arr.slice(0, this.topN).forEach(c => codes.add(c)); 
						} 
					});
					map[day]=Array.from(codes);
				}
				this.prevCodesByDay=map;
			}
			,
			async prefetchPrevDaysForHighlights(){
				const plateType=17;
				const dataSrc=this.showKP ? 2 : 1;
				const nDays=this.selectedCycle;
				const extraDays = this.allDays.slice(this.dayn, this.dayn+3);
				const reqs = extraDays.map(d=> request_zzquant({url:`/market/plates/${plateType}/rank/days?date2=${d}&n_days=${nDays}&data_src=${dataSrc}&n_type=${this.selectedNType}`})
					.then(r=>{ const arr=r.data && r.data.data ? r.data.data : []; this.$set(this.loadedCodesByDay, d, arr.map(it=> it.plate_code).filter(Boolean)); })
					.catch(()=>{ this.$set(this.loadedCodesByDay, d, []); })
				);
				return Promise.all(reqs);
			},
			// 板块爆发原因相关方法
			loadPlateReasons() {
				if (!this.selectedPlateCode) return;
				this.loadingReasons = true;
				this.reasonAuthRequired = false;
				try {
					const tk = localStorage.getItem('token');
					if (!tk) this.reasonAuthRequired = true;
				} catch (e) { /* ignore */ }
				request_zzquant({
					url: `/market/plate/popular/reason?plate_code=${this.selectedPlateCode}`,
					noRedirect: true
				})
					.then(res => {
						const data = res && res.data && res.data.data ? res.data.data : [];
						this.plateReasons = Array.isArray(data) ? data : [];
						this.reasonContentMap = {};
						this.reasonLoadingContent = {};
						this.reasonExpanded = {};
					})
					.catch(err => {
						console.log(err);
						const msg = (err && err.message) ? String(err.message) : '';
						const hints = ['无权限','未登录','验证失败','Unauthorized','需要登录','未授权'];
						const status401 = !!(err && err.status === 401);
						const unauthorized = !!(err && err.__unauthorized);
						const byMsg = hints.some(h => msg.indexOf(h) !== -1);
						this.reasonAuthRequired = !!(status401 || unauthorized || byMsg);
						this.plateReasons = [];
					})
					.finally(() => {
						this.loadingReasons = false;
					});
			},
			toggleReason(r) {
				const id = r.newid;
				if (!id) return;
				if (this.reasonExpanded[id]) {
					this.$set(this.reasonExpanded, id, false);
					return;
				}
				if (this.reasonContentMap[id]) {
					this.$set(this.reasonExpanded, id, true);
					return;
				}
				this.$set(this.reasonLoadingContent, id, true);
				request_zzquant({
					url: `/market/plate/popular/reason/content?msgid=${id}`,
					noRedirect: true
				})
					.then(res => {
						const d = res && res.data && res.data.data ? res.data.data : null;
						const title = d && (d.Title || d.title) ? (d.Title || d.title) : '';
						const contentHtml = d && (d.Content || d.content) ? (d.Content || d.content) : '';
						const createTime = d && (d.CreateTime || d.createTime || d.create_time) ? (d.CreateTime || d.createTime || d.create_time) : null;
						this.$set(this.reasonContentMap, id, { title, content: contentHtml, createTime });
						this.$set(this.reasonExpanded, id, true);
					})
					.catch(err => {
						console.log(err);
						this.$set(this.reasonContentMap, id, { title: '', content: '<div style="color:#d23">内容加载失败</div>', createTime: null });
						this.$set(this.reasonExpanded, id, true);
					})
					.finally(() => {
						this.$set(this.reasonLoadingContent, id, false);
					});
			},
			formatReasonTimestamp(ts) {
				if (!ts) return '';
				const num = typeof ts === 'number' ? ts : parseInt(ts, 10);
				if (!num) return '';
				const d = new Date(num * 1000);
				const y = d.getFullYear();
				const m = String(d.getMonth() + 1).padStart(2, '0');
				const day = String(d.getDate()).padStart(2, '0');
				const hh = String(d.getHours()).padStart(2, '0');
				const mm = String(d.getMinutes()).padStart(2, '0');
				return `${y}-${m}-${day} ${hh}:${mm}`;
			},
			goLogin() {
				try {
					const current = this.$route && this.$route.fullPath ? this.$route.fullPath : '/';
					this.$router.push({ path: '/login', query: { redirect: current } });
				} catch (e) { /* ignore */ }
			},
			
			// 同步水平滚动
			handleScroll(active) {
				const refs = ['scrollTopic', 'scrollIntensity', 'scrollVolume', 'scrollLadder', 'scrollPopular', 'scrollPct'];
				const activeRef = this.$refs[active];
				if (!activeRef) return;
				
				const scrollLeft = activeRef.scrollLeft;
				refs.forEach(r => {
					if (r !== active && this.$refs[r]) {
						this.$refs[r].scrollLeft = scrollLeft;
					}
				});
			}
		}
	}
</script>

<style>
.b-form-datepicker {
    max-width: 300px;
}
</style>

<style scoped>
.wonder-ml-page {
	--col-width: 140px;
}
@media (max-width: 768px) {
	.wonder-ml-page {
		--col-width: 150px;
	}
}

.ranking-item {
	border: 1px solid var(--border-color, lightgray);
	color: var(--text-main, #333);
	border-radius: 4px;
	padding: 2px 6px;
	background-color: var(--bg-card, #fff);
	width: 100%;
	min-height: 32px;
	line-height: 24px;
	font-size: 12px;
	transition: min-height 0.2s;
}
.has-row2 .ranking-item {
	min-height: 48px;
}
.ranking-highlight-1 {
	background-color: #dc3545 !important;
	color: #fff !important;
	border-color: #dc3545 !important;
}
.ranking-highlight-2 {
	background-color: #ffc107 !important;
	color: #212529 !important;
	border-color: #ffc107 !important;
}

/* 板块爆发原因样式 */
.plate-reasons {
	margin-top: 16px;
	border-top: 1px solid var(--border-color);
	padding-top: 12px;
	max-height: 300px;
	overflow-y: auto;
}
.plate-reasons-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: var(--text-main);
	margin-bottom: 10px;
}
.plate-reasons-header h5 {
	margin: 0;
	font-size: 14px;
}
.plate-reasons .loading { font-size: 12px; color: var(--text-muted); }
.plate-reasons .empty { font-size: 13px; color: var(--text-muted); }
.plate-reasons .login-btn { margin-left: 8px; padding: 2px 10px; border-radius: 16px; font-size: 12px; }
.reasons-list { display: flex; flex-direction: column; gap: 10px; }
.reason-item { padding: 8px; border: 1px solid var(--border-color); border-radius: 6px; background-color: var(--bg-card); }
.reason-title { display: flex; gap: 8px; align-items: center; font-weight: 600; flex-wrap: wrap; }
.reason-title .date { font-size: 12px; color: var(--text-muted); }
.reason-title .boom { font-size: 12px; color: #d23; border: 1px solid #d23; border-radius: 3px; padding: 0 4px; }
.reason-title .title { font-size: 14px; color: var(--accent-color); text-decoration: none; cursor: pointer; }
.reason-meta { display: flex; gap: 12px; font-size: 12px; color: var(--text-muted); margin-top: 4px; }
.reason-text { font-size: 13px; margin-top: 6px; line-height: 1.4; color: #d23; }
.reason-lz { font-size: 12px; margin-top: 4px; color: var(--text-main); }
.reason-content { margin-top: 8px; font-size: 13px; line-height: 1.6; color: var(--text-main); }
.reason-detail-meta { font-size: 12px; color: var(--text-muted); margin-bottom: 6px; }

/* Mode switch item styles */
.mode-switch-item {
	font-size: 12px;
	font-weight: bold;
	color: #ced4da;
	cursor: pointer;
	padding: 4px 2px;
	border-radius: 4px;
	transition: all 0.2s;
	width: 36px;
	text-align: center;
	border: 1px solid transparent;
}
.mode-switch-item:hover {
	color: var(--primary, #007bff);
	background-color: rgba(0, 123, 255, 0.05);
}
.mode-switch-item.active {
	color: #fff;
	background-color: var(--primary, #007bff);
	border-color: var(--primary, #007bff);
}

/* 锁定遮罩及模糊效果样式 */
.locked-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(12px) saturate(180%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

body.theme-dark .locked-overlay {
  background: rgba(15, 23, 42, 0.35);
}

.lock-circle {
  width: 56px;
  height: 56px;
  background: rgba(255, 193, 7, 0.15);
  color: #ffc107;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border: 1px solid rgba(255, 193, 7, 0.3);
  box-shadow: 0 0 20px rgba(255, 193, 7, 0.1);
  animation: lock-float 3s ease-in-out infinite;
}

.blur-content {
  filter: blur(12px);
  pointer-events: none;
  opacity: 0.45;
  transition: all 0.4s ease;
}

@keyframes lock-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}
</style>
